import {useAppContext} from 'contexts/ApplicationContext';
import {useJobContext} from 'contexts/JobContext';
import {PartialJob} from 'shared/types/PartialJob';

export const useCaptureDeliveryInfo = () => {
    const {userProfile} = useAppContext();
    const {isJobProcessing} = useJobContext() as PartialJob;

    return (
        !!userProfile?.jobConfirmationEnabled &&
        !userProfile?.capturePickupFreightAtJobCreation &&
        isJobProcessing
    );
};
